// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'
import jwtDefaultConfig2 from './jwtDefaultConfig'

const { jwt } = useJwt(jwtDefaultConfig2)

export default jwt
